<template>
    <div
      class="container" 
      style="background-color: #fff; padding-top: 15px;border-left:1px solid #ddd;border-right:1px solid #ddd;margin-bottom:0px;padding-bottom:15px;"
    >

      <h2><i class="bi bi-sliders"></i> Account</h2>
      <p>There are currently no account settings you can modify. We are working on this, in the meantime you can contact support@geofolio.org for questions about your account.</p>


  </div>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {
      f_type: "ldr",
      loaded: false,
    };
  },
  created() {
  },
  components: {
  },
  mounted() {},
  computed: {
    profile() {
      return this.getProfile();
    },
  },
  watch: {
    loaded: function () {},
  },
  methods: {
  },
  name: "Account",
};
</script>

<style></style>

<style scoped>
h2 {
  font-size: 1.5em;
  font-weight: 600;
  color: #666;
  margin-bottom:15px;
}
p {
  margin:0px;
  font-size:18px;
  color:#666;
}
</style>
